<span
  class="wp-replacement-label"
  (click)="activate($event)"
  tabindex="-1">
  <ng-content></ng-content>
</span>
